// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1nHXy","title":"AfterBackImages_title__2jTPc","images":"AfterBackImages_images__3hJ0d"};